import React, { useEffect, useState } from "react";
import "./ScrambleaWordPlay.css";
import logo from "../../../assets/images/coinlogo.png";
import { userGameRewards } from "../../../apis/user";
import useUserInfo from "../../../Hooks/useUserInfo";
import cancelIcon from "../../../assets/Task/cancelicon.svg";
import scramble from "./ScrambleaWord";
import { useAudio } from "../../../Providers/AudioProvider";
import { logPageView } from "../../../components/analytics";

const gameData = [{
  answer: "YELLOW",
  hint: "BRIGHT AND SUNNY COLOR",
  letters: ["Y", "E", "L", "L", "W", "O"],
  word: "YELLOW"
  }, {
  answer: "MAP",
  hint: "USED FOR NAVIGATION & FINDING PLACES",
  letters: ["M", "A", "P"],
  word: "MAP"
  },{
  answer: "RAINBOW",
  hint: "COLORFUL ARC IN THE SKY",
  letters: ["R", "A", "I", "N", "W", "B", "O"],
  word: "RAINBOW"
  }, {
  answer: "AIRPLANE",
  hint: "FLIES IN THE SKY",
  letters: ["A", "I", "R", "A", "E", "N", "L", "P"],
  word: "AIRPLANE"
  }, {
  answer: "ZEBRA",
  hint: "ANIMAL WITH BLACK AND WHITE STRIPES",
  letters: ["Z", "E", "B", "A", "R"],
  word: "ZEBRA"
  }, {
  answer: "OCEAN",
  hint: "LARGE BODY OF SALTWATER",
  letters: ["O", "C", "E", "N", "A"],
  word: "OCEAN"
  }, {
  answer: "MIRROR",
  hint: "REFLECTIVE SURFACE",
  letters: ["M", "I", "R", "O", "R", "R"],
  word: "MIRROR"
  }, {
  answer: "FLOWER",
  hint: "COLORFUL BLOSSOM",
  letters: ["F", "L", "O", "W", "R", "E"],
  word: "FLOWER"
  }, {
  answer: "CAROUSEL",
  hint: "MERRY GO ROUND",
  letters: ["C", "A", "R", "O", "U", "S", "L", "E"],
  word: "CAROUSEL"
  }, {
  answer: "CLOUD",
  hint: "FLUFFY SKY FORMATION",
  letters: ["C", "L", "O", "D", "U"],
  word: "CLOUD"
  }, {
  answer: "GUITAR",
  hint: "STRING INSTRUMENT",
  letters: ["G", "U", "I", "T", "R", "A"],
  word: "GUITAR"
  }, {
  answer: "JUNGLE",
  hint: "DENSE FOREST",
  letters: ["J", "U", "N", "G", "E", "L"],
  word: "JUNGLE"
  }, {
  answer: "SUNSET",
  hint: "EVENING SKY COLORATION",
  letters: ["S", "U", "N", "S", "T", "E"],
  word: "SUNSET"
  }, {
  answer: "CHERRY",
  hint: "SMALL RED FRUIT",
  letters: ["C", "H", "E", "R", "Y", "R"],
  word: "CHERRY"
  }, {
  answer: "LIGHT",
  hint: "ILLUMINATING THE DARK",
  letters: ["L", "I", "G", "T", "H"],
  word: "LIGHT"
  }, {
  answer: "SPARROW",
  hint: "SMALL BIRD",
  letters: ["S", "P", "A", "R", "R", "W", "O"],
  word: "SPARROW"
  }, {
  answer: "MARATHON",
  hint: "LONG DISTANCE RACE",
  letters: ["M", "A", "R", "A", "T", "H", "N", "O"],
  word: "MARATHON"
  }, {
  answer: "LANTERN",
  hint: "PORTABLE LIGHT",
  letters: ["L", "A", "N", "T", "E", "N", "R"],
  word: "LANTERN"
  }, {
  answer: "CANDLE",
  hint: "WAX LIGHT SOURCE",
  letters: ["C", "A", "N", "D", "E", "L"],
  word: "CANDLE"
  }, {
  answer: "UNICORN",
  hint: "MYTHICAL HORSE WITH A HORN",
  letters: ["U", "N", "I", "C", "O", "N", "R"],
  word: "UNICORN"
  }, {
  answer: "BALLOON",
  hint: "FLOATING PARTY DECORATION",
  letters: ["B", "A", "L", "L", "O", "N", "O"],
  word: "BALLOON"
  }, {
  answer: "BICYCLE",
  hint: "TWO WHEELED VEHICLE",
  letters: ["B", "I", "C", "Y", "C", "E", "L"],
  word: "BICYCLE"
  }, {
  answer: "ISLAND",
  hint: "LAND SURROUNDED BY WATER",
  letters: ["I", "S", "L", "A", "D", "N"],
  word: "ISLAND"
  }, {
  answer: "DIAMOND",
  hint: "PRECIOUS GEMSTONE",
  letters: ["D", "I", "A", "M", "O", "D", "N"],
  word: "DIAMOND"
  }, {
  answer: "MONSOON",
  hint: "SEASONAL RAINSTORM",
  letters: ["M", "O", "N", "S", "O", "N", "O"],
  word: "MONSOON"
  }, {
  answer: "ORANGE",
  hint: "CITRUS FRUIT",
  letters: ["O", "R", "A", "N", "E", "G"],
  word: "ORANGE"
  }, {
  answer: "DINOSAUR",
  hint: "EXTINCT REPTILE",
  letters: ["D", "I", "N", "O", "S", "A", "R", "U"],
  word: "DINOSAUR"
  }, {
  answer: "BUTTER",
  hint: "SMOOTH AND CREAMY SPREAD",
  letters: ["B", "U", "T", "T", "R", "E"],
  word: "BUTTER"
  }, {
  answer: "FOUNTAIN",
  hint: "WATER FEATURE",
  letters: ["F", "O", "U", "N", "T", "A", "N", "I"],
  word: "FOUNTAIN"
  }, {
  answer: "TREASURE",
  hint: "VALUABLE ITEMS",
  letters: ["T", "R", "E", "A", "S", "U", "E", "R"],
  word: "TREASURE"
  }, {
  answer: "SNOW",
  hint: "WINTER'S WHITE BLANKET",
  letters: ["S", "N", "W", "O"],
  word: "SNOW"
  }, {
  answer: "CANYON",
  hint: "DEEP VALLEY",
  letters: ["C", "A", "N", "Y", "N", "O"],
  word: "CANYON"
  }, {
  answer: "SUNSHINE",
  hint: "LIGHT FROM THE SUN",
  letters: ["S", "U", "N", "S", "H", "I", "E", "N"],
  word: "SUNSHINE"
  }, {
  answer: "SCORPION",
  hint: "ARACHNID WITH A STINGER",
  letters: ["S", "C", "O", "R", "P", "I", "N", "O"],
  word: "SCORPION"
  }, {
  answer: "LADDER",
  hint: "CLIMBING TOOL",
  letters: ["L", "A", "D", "D", "R", "E"],
  word: "LADDER"
  }, {
  answer: "WIZARD",
  hint: "SPELLCASTER",
  letters: ["W", "I", "Z", "A", "D", "R"],
  word: "WIZARD"
  }, {
  answer: "PARROT",
  hint: "COLORFUL TALKING BIRD",
  letters: ["P", "A", "R", "O", "R", "T"],
  word: "PARROT"
  }, {
  answer: "MERMAID",
  hint: "HALF WOMAN AND HALF FISH",
  letters: ["M", "E", "R", "M", "A", "D", "I"],
  word: "MERMAID"
  }, {
  answer: "ROCKET",
  hint: "SPACE VEHICLE",
  letters: ["R", "O", "C", "K", "T", "E"],
  word: "ROCKET"
  }, {
  answer: "DRAGON",
  hint: "FIRE BREATHING CREATURE",
  letters: ["D", "R", "A", "G", "N", "O"],
  word: "DRAGON"
  }, {
  answer: "TIGER",
  hint: "STRIPED BIG CAT",
  letters: ["T", "I", "G", "R", "E"],
  word: "TIGER"
  }, {
  answer: "PICTURE",
  hint: "A CAPTURED MOMENT",
  letters: ["P", "I", "C", "T", "U", "E", "R"],
  word: "PICTURE"
  }, {
  answer: "MYSTERY",
  hint: "UNSOLVED PUZZLE",
  letters: ["M", "Y", "S", "T", "E", "Y", "R"],
  word: "MYSTERY"
  }, {
  answer: "BATTERY",
  hint: "PORTABLE ENERGY SOURCE",
  letters: ["B", "A", "T", "T", "E", "Y", "R"],
  word: "BATTERY"
  }, {
  answer: "HOUSE",
  hint: "FOUR WALLS AND A ROOF",
  letters: ["H", "O", "U", "E", "S"],
  word: "HOUSE"
  }, {
  answer: "SEAHORSE",
  hint: "SMALL MARINE FISH",
  letters: ["S", "E", "A", "H", "O", "R", "E", "S"],
  word: "SEAHORSE"
  }, {
  answer: "KITE",
  hint: "FLIES WITH THE WIND",
  letters: ["K", "I", "E", "T"],
  word: "KITE"
  }, {
  answer: "FERRIS",
  hint: "WHEEL AT A CARNIVAL",
  letters: ["F", "E", "R", "R", "S", "I"],
  word: "FERRIS"
  }, {
  answer: "PEACOCK",
  hint: "BIRD WITH EYE SPOTTED TAIL",
  letters: ["P", "E", "A", "C", "O", "K", "C"],
  word: "PEACOCK"
  }, {
  answer: "METEOR",
  hint: "SHOOTING STAR",
  letters: ["M", "E", "T", "E", "R", "O"],
  word: "METEOR"
  }, {
  answer: "PYTHON",
  hint: "LARGE CONSTRICTOR SNAKE",
  letters: ["P", "Y", "T", "H", "N", "O"],
  word: "PYTHON"
  }, {
  answer: "BUNGALOW",
  hint: "SINGLE STORY HOUSE",
  letters: ["B", "U", "N", "G", "A", "L", "W", "O"],
  word: "BUNGALOW"
  }, {
  answer: "GOBLIN",
  hint: "MISCHIEVOUS CREATURE",
  letters: ["G", "O", "B", "L", "N", "I"],
  word: "GOBLIN"
  }, {
  answer: "MUSEUM",
  hint: "PLACE TO SEE ARTIFACTS",
  letters: ["M", "U", "S", "E", "M", "U"],
  word: "MUSEUM"
  }, {
  answer: "ROULETTE",
  hint: "CASINO GAME",
  letters: ["R", "O", "U", "L", "E", "T", "E", "T"],
  word: "ROULETTE"
  }, {
  answer: "BALLET",
  hint: "CLASSICAL DANCE",
  letters: ["B", "A", "L", "L", "T", "E"],
  word: "BALLET"
  }, {
  answer: "JUPITER",
  hint: "LARGEST PLANET",
  letters: ["J", "U", "P", "I", "T", "R", "E"],
  word: "JUPITER"
  }, {
  answer: "CIRCUS",
  hint: "ENTERTAINMENT TENT",
  letters: ["C", "I", "R", "C", "S", "U"],
  word: "CIRCUS"
  }, {
  answer: "TOURIST",
  hint: "TRAVELER ON VACATION",
  letters: ["T", "O", "U", "R", "I", "T", "S"],
  word: "TOURIST"
  }, {
  answer: "ROBOT",
  hint: "MACHINE THAT PERFORMS TASKS",
  letters: ["R", "O", "B", "T", "O"],
  word: "ROBOT"
  }, {
  answer: "PHOENIX",
  hint: "MYTHICAL BIRD THAT RISES FROM ASHES",
  letters: ["P", "H", "O", "E", "N", "X", "I"],
  word: "PHOENIX"
  }, {
  answer: "PRINCE",
  hint: "A ROYAL SON",
  letters: ["P", "R", "I", "N", "E", "C"],
  word: "PRINCE"
  }, {
  answer: "CARNIVAL",
  hint: "FAIR WITH RIDES AND GAMES",
  letters: ["C", "A", "R", "N", "I", "V", "L", "A"],
  word: "CARNIVAL"
  }, {
  answer: "EAGLE",
  hint: "BIRD OF PREY",
  letters: ["E", "A", "G", "E", "L"],
  word: "EAGLE"
  }, {
  answer: "WILLOW",
  hint: "TREE WITH DROOPING BRANCHES",
  letters: ["W", "I", "L", "L", "W", "O"],
  word: "WILLOW"
  }, {
  answer: "HORIZON",
  hint: "WHERE EARTH MEETS SKY",
  letters: ["H", "O", "R", "I", "Z", "N", "O"],
  word: "HORIZON"
  }, {
  answer: "KETTLE",
  hint: "HOT WATER CONTAINER",
  letters: ["K", "E", "T", "T", "E", "L"],
  word: "KETTLE"
  }, {
  answer: "MANDARIN",
  hint: "TYPE OF ORANGE",
  letters: ["M", "A", "N", "D", "A", "R", "N", "I"],
  word: "MANDARIN"
  }, {
  answer: "BLIZZARD",
  hint: "SEVERE SNOWSTORM",
  letters: ["B", "L", "I", "Z", "Z", "A", "D", "R"],
  word: "BLIZZARD"
  }, {
  answer: "MYSTIC",
  hint: "ENIGMATIC, SPIRITUAL",
  letters: ["M", "Y", "S", "T", "C", "I"],
  word: "MYSTIC"
  }, {
  answer: "NARWHAL",
  hint: "ARCTIC WHALE WITH A TUSK",
  letters: ["N", "A", "R", "W", "H", "L", "A"],
  word: "NARWHAL"
  }, {
  answer: "SPHINX",
  hint: "EGYPTIAN MYTHICAL CREATURE",
  letters: ["S", "P", "H", "I", "X", "N"],
  word: "SPHINX"
  }, {
  answer: "KOI",
  hint: "JAPANESE FISH",
  letters: ["K", "I", "O"],
  word: "KOI"
  }, {
  answer: "GOBLET",
  hint: "DRINKING VESSEL",
  letters: ["G", "O", "B", "L", "T", "E"],
  word: "GOBLET"
  }, {
  answer: "PYGMY",
  hint: "SHORT IN STATURE",
  letters: ["P", "Y", "G", "Y", "M"],
  word: "PYGMY"
  }, {
  answer: "CUPID",
  hint: "MYTHICAL LOVE ARCHER",
  letters: ["C", "U", "P", "D", "I"],
  word: "CUPID"
  }, {
  answer: "LAGOON",
  hint: "SHALLOW BODY OF WATER",
  letters: ["L", "A", "G", "O", "N", "O"],
  word: "LAGOON"
  }, {
  answer: "TOUCAN",
  hint: "BIRD WITH A LARGE BEAK",
  letters: ["T", "O", "U", "C", "N", "A"],
  word: "TOUCAN"
  }, {
  answer: "ZUCCHINI",
  hint: "GREEN VEGETABLE",
  letters: ["Z", "U", "C", "C", "H", "I", "I", "N"],
  word: "ZUCCHINI"
  }, {
  answer: "ANCHOR",
  hint: "KEEPS A SHIP IN PLACE",
  letters: ["A", "N", "C", "H", "R", "O"],
  word: "ANCHOR"
  }, {
  answer: "RUBY",
  hint: "RED GEMSTONE",
  letters: ["R", "U", "Y", "B"],
  word: "RUBY"
  }, {
  answer: "BEEHIVE",
  hint: "HOME FOR HONEY MAKERS",
  letters: ["B", "E", "E", "H", "I", "E", "V"],
  word: "BEEHIVE"
  }, {
  answer: "PIZZA",
  hint: "ITALIAN DISH WITH CHEESE AND SAUCE",
  letters: ["P", "I", "Z", "A", "Z"],
  word: "PIZZA"
  }, {
  answer: "LION",
  hint: "KING OF THE JUNGLE",
  letters: ["L", "I", "N", "O"],
  word: "LION"
  }, {
  answer: "TUNNEL",
  hint: "UNDERGROUND PASSAGE",
  letters: ["T", "U", "N", "N", "L", "E"],
  word: "TUNNEL"
  }, {
  answer: "EQUATOR",
  hint: "DIVIDES EARTH INTO TWO HEMISPHERES",
  letters: ["E", "Q", "U", "A", "T", "R", "O"],
  word: "EQUATOR"
  }, {
  answer: "PENGUIN",
  hint: "FLIGHTLESS ANTARCTIC BIRD",
  letters: ["P", "E", "N", "G", "U", "N", "I"],
  word: "PENGUIN"
  }, {
  answer: "MOSQUITO",
  hint: "INSECT THAT BITES",
  letters: ["M", "O", "S", "Q", "U", "I", "O", "T"],
  word: "MOSQUITO"
  }, {
  answer: "PUMPKIN",
  hint: "COMMONLY CARVED DURING HALLOWEEN",
  letters: ["P", "U", "M", "P", "K", "N", "I"],
  word: "PUMPKIN"
  }, {
  answer: "COCONUT",
  hint: "TROPICAL FRUIT WITH HARD SHELL",
  letters: ["C", "O", "C", "O", "N", "T", "U"],
  word: "COCONUT"
  }, {
  answer: "VIOLIN",
  hint: "STRING INSTRUMENT PLAYED WITH A BOW",
  letters: ["V", "I", "O", "L", "N", "I"],
  word: "VIOLIN"
  }, {
  answer: "APPLE",
  hint: "KEEPS THE DOCTOR AWAY",
  letters: ["A", "P", "P", "E", "L"],
  word: "APPLE"
  }, {
  answer: "MARINE",
  hint: "ANYTHING RELATED TO OCEAN",
  letters: ["M", "A", "R", "I", "E", "N"],
  word: "MARINE"
  }, {
  answer: "AVOCADO",
  hint: "CREAMY GREEN FRUIT",
  letters: ["A", "V", "O", "C", "A", "O", "D"],
  word: "AVOCADO"
  }, {
  answer: "VAMPIRE",
  hint: "MYTHICAL CREATURE THAT DRINKS BLOOD",
  letters: ["V", "A", "M", "P", "I", "E", "R"],
  word: "VAMPIRE"
  }, {
  answer: "PYRAMID",
  hint: "ANCIENT STRUCTURE IN EGYPT",
  letters: ["P", "Y", "R", "A", "M", "D", "I"],
  word: "PYRAMID"
  }, {
  answer: "ORCHID",
  hint: "EXOTIC BLOOMING PLANT",
  letters: ["O", "R", "C", "H", "D", "I"],
  word: "ORCHID"
  }, {
  answer: "SAPPHIRE",
  hint: "PRECIOUS BLUE STONE",
  letters: ["S", "A", "P", "P", "H", "I", "E", "R"],
  word: "SAPPHIRE"
  }, {
  answer: "GAZELLE",
  hint: "SWIFT ANTELOPE",
  letters: ["G", "A", "Z", "E", "L", "E", "L"],
  word: "GAZELLE"
  }, {
  answer: "SEQUOIA",
  hint: "TALL REDWOOD TREE",
  letters: ["S", "E", "Q", "U", "O", "A", "I"],
  word: "SEQUOIA"
  }, {
  answer: "CAKE",
  hint: "PERFECT FOR CELEBRATIONS",
  letters: ["C", "A", "E", "K"],
  word: "CAKE"
  }, {
  answer: "ALMOND",
  hint: "NUT USED IN SNACKS AND MILK",
  letters: ["A", "L", "M", "O", "D", "N"],
  word: "ALMOND"
  }, {
  answer: "LIZARD",
  hint: "REPTILE WITH FOUR LEGS",
  letters: ["L", "I", "Z", "A", "D", "R"],
  word: "LIZARD"
  }, {
  answer: "IGLOO",
  hint: "DOME SHAPED SHELTER MADE OF ICE",
  letters: ["I", "G", "O", "L", "O"],
  word: "IGLOO"
  }, {
  answer: "FLOUR",
  hint: "BAKING ESSENTIAL",
  letters: ["F", "L", "O", "R", "U"],
  word: "FLOUR"
  }, {
  answer: "JASMINE",
  hint: "FRAGRANT FLOWER",
  letters: ["J", "A", "S", "M", "I", "E", "N"],
  word: "JASMINE"
  }, {
  answer: "CENTAUR",
  hint: "MYTHICAL CREATURE HALF MAN, HALF HORSE",
  letters: ["C", "E", "N", "T", "A", "R", "U"],
  word: "CENTAUR"
  }, {
  answer: "CAMEL",
  hint: "DESERT DWELLING ANIMAL WITH HUMP",
  letters: ["C", "A", "M", "L", "E"],
  word: "CAMEL"
  }, {
  answer: "UMBRELLA",
  hint: "KEEPS YOU DRY IN RAIN",
  letters: ["U", "M", "B", "R", "E", "L", "A", "L"],
  word: "UMBRELLA"
  }, {
  answer: "SNOWMAN",
  hint: "WINTER FIGURE MADE OF FROZEN WATER",
  letters: ["S", "N", "O", "W", "M", "N", "A"],
  word: "SNOWMAN"
  }, {
  answer: "TRIANGLE",
  hint: "THREE SIDED SHAPE",
  letters: ["T", "R", "I", "A", "N", "G", "E", "L"],
  word: "TRIANGLE"
  }, {
  answer: "PHONE",
  hint: "CALL AND CONNECT",
  letters: ["P", "H", "O", "E", "N"],
  word: "PHONE"
  }, {
  answer: "MONKEY",
  hint: "PLAYFUL JUNGLE CREATURE",
  letters: ["M", "O", "N", "K", "Y", "E"],
  word: "MONKEY"
  }, {
  answer: "DINGO",
  hint: "WILD DOG OF AUSTRALIA",
  letters: ["D", "I", "N", "O", "G"],
  word: "DINGO"
  }, {
  answer: "NEPTUNE",
  hint: "ROMAN GOD OF THE SEA",
  letters: ["N", "E", "P", "T", "U", "E", "N"],
  word: "NEPTUNE"
  }, {
  answer: "VENUS",
  hint: "PLANET KNOWN AS THE MORNING STAR",
  letters: ["V", "E", "N", "S", "U"],
  word: "VENUS"
  }, {
  answer: "AMETHYST",
  hint: "PURPLE GEMSTONE",
  letters: ["A", "M", "E", "T", "H", "Y", "T", "S"],
  word: "AMETHYST"
  }, {
  answer: "WALNUT",
  hint: "NUT USED IN BAKING AND COOKING",
  letters: ["W", "A", "L", "N", "T", "U"],
  word: "WALNUT"
  }, {
  answer: "BUFFALO",
  hint: "LARGE, HEAVY CATTLE-LIKE ANIMAL",
  letters: ["B", "U", "F", "F", "A", "O", "L"],
  word: "BUFFALO"
  }, {
  answer: "NAIL",
  hint: "SHARP AND POINTED",
  letters: ["N", "A", "L", "I"],
  word: "NAIL"
  }, {
  answer: "MANGROVE",
  hint: "COASTAL TREE WITH ROOTS ABOVE WATER",
  letters: ["M", "A", "N", "G", "R", "O", "E", "V"],
  word: "MANGROVE"
  }, {
  answer: "RACCOON",
  hint: "NOCTURNAL ANIMAL WITH A MASK-LIKE FACE",
  letters: ["R", "A", "C", "C", "O", "N", "O"],
  word: "RACCOON"
  }, {
  answer: "BARNACLE",
  hint: "SMALL SEA CREATURE THAT ATTACHES TO SURFACES",
  letters: ["B", "A", "R", "N", "A", "C", "E", "L"],
  word: "BARNACLE"
  }, {
  answer: "LADYBUG",
  hint: "SMALL RED BEETLE WITH BLACK SPOTS",
  letters: ["L", "A", "D", "Y", "B", "G", "U"],
  word: "LADYBUG"
  }, {
  answer: "OYSTER",
  hint: "BIVALVE THAT MAKES PEARLS",
  letters: ["O", "Y", "S", "T", "R", "E"],
  word: "OYSTER"
  }, {
  answer: "PLATYPUS",
  hint: "AUSTRALIAN MAMMAL THAT LAYS EGGS",
  letters: ["P", "L", "A", "T", "Y", "P", "S", "U"],
  word: "PLATYPUS"
  }, {
  answer: "WOLF",
  hint: "HOWLING AT THE MOON",
  letters: ["W", "O", "F", "L"],
  word: "WOLF"
  }, {
  answer: "ANACONDA",
  hint: "LARGE SOUTH AMERICAN SNAKE",
  letters: ["A", "N", "A", "C", "O", "N", "A", "D"],
  word: "ANACONDA"
  }, {
  answer: "GORILLA",
  hint: "LARGEST LIVING PRIMATE",
  letters: ["G", "O", "R", "I", "L", "A", "L"],
  word: "GORILLA"
  }, {
  answer: "SHARK",
  hint: "FIERCE PREDATOR OF THE OCEAN",
  letters: ["S", "H", "A", "K", "R"],
  word: "SHARK"
  }, {
  answer: "WATCH",
  hint: "TIME TELLING ACCESSORY",
  letters: ["W", "A", "T", "H", "C"],
  word: "WATCH"
  }, {
  answer: "SAND",
  hint: "GRAINS OF THE EARTH",
  letters: ["S", "A", "D", "N"],
  word: "SAND"
  }, {
  answer: "KANGAROO",
  hint: "ANIMAL KNOWN FOR HOPPING",
  letters: ["K", "A", "N", "G", "A", "O", "R", "O"],
  word: "KANGAROO"
  }, {
  answer: "TORTOISE",
  hint: "SLOW MOVING REPTILE",
  letters: ["T", "O", "R", "T", "O", "I", "E", "S"],
  word: "TORTOISE"
  }, {
  answer: "RAVEN",
  hint: "LARGE BLACK BIRD",
  letters: ["R", "A", "V", "N", "E"],
  word: "RAVEN"
  }, {
  answer: "MUSHROOM",
  hint: "FUNGI OFTEN USED IN COOKING",
  letters: ["M", "U", "S", "H", "R", "O", "M", "O"],
  word: "MUSHROOM"
  }, {
  answer: "QUARTZ",
  hint: "HARD MINERAL USED IN JEWELRY",
  letters: ["Q", "U", "A", "R", "Z", "T"],
  word: "QUARTZ"
  }, {
  answer: "FLASK",
  hint: "METAL OR GLASS BOTTLE",
  letters: ["F", "L", "A", "K", "S"],
  word: "FLASK"
  }, {
  answer: "FIRE",
  hint: "BURNING ENERGY",
  letters: ["F", "I", "E", "R"],
  word: "FIRE"
  }, {
  answer: "CACTUS",
  hint: "SPINY PLANT FOUND IN DESERTS",
  letters: ["C", "A", "C", "T", "S", "U"],
  word: "CACTUS"
  }, {
  answer: "OCTAGON",
  hint: "EIGHT SIDED SHAPE",
  letters: ["O", "C", "T", "A", "G", "N", "O"],
  word: "OCTAGON"
  }, {
  answer: "WHISTLE",
  hint: "DEVICE THAT MAKES A SHARP SOUND",
  letters: ["W", "H", "I", "S", "T", "E", "L"],
  word: "WHISTLE"
  }, {
  answer: "CORAL",
  hint: "MARINE ORGANISM THAT FORMS REEFS",
  letters: ["C", "O", "R", "L", "A"],
  word: "CORAL"
  }, {
  answer: "RABBIT",
  hint: "HOPPING ANIMAL WITH LONG EARS",
  letters: ["R", "A", "B", "B", "T", "I"],
  word: "RABBIT"
  }, {
  answer: "SQUIRREL",
  hint: "RODENT THAT STORES NUTS",
  letters: ["S", "Q", "U", "I", "R", "R", "L", "E"],
  word: "SQUIRREL"
  }, {
  answer: "KITTEN",
  hint: "YOUNG CAT",
  letters: ["K", "I", "T", "T", "N", "E"],
  word: "KITTEN"
  }, {
  answer: "RHINO",
  hint: "ANIMAL WITH A HORNED SNOUT",
  letters: ["R", "H", "I", "O", "N"],
  word: "RHINO"
  }, {
  answer: "VOLCANO",
  hint: "MOUNTAIN THAT ERUPTS",
  letters: ["V", "O", "L", "C", "A", "O", "N"],
  word: "VOLCANO"
  }, {
  answer: "BANANA",
  hint: "YELLOW FRUIT WITH PEEL",
  letters: ["B", "A", "N", "A", "A", "N"],
  word: "BANANA"
  }, {
  answer: "JELLY",
  hint: "WOBBLY SWEET TREAT",
  letters: ["J", "E", "L", "Y", "L"],
  word: "JELLY"
  }, {
  answer: "FERRARI",
  hint: "LUXURY ITALIAN SPORTS CAR",
  letters: ["F", "E", "R", "R", "A", "I", "R"],
  word: "FERRARI"
  }, {
  answer: "EQUINOX",
  hint: "DAY WITH EQUAL DAY AND NIGHT",
  letters: ["E", "Q", "U", "I", "N", "X", "O"],
  word: "EQUINOX"
  }, {
  answer: "BARCODE",
  hint: "SCANNABLE ITEM CODE",
  letters: ["B", "A", "R", "C", "O", "E", "D"],
  word: "BARCODE"
  }, {
  answer: "PIRANHA",
  hint: "SHARP TOOTHED FISH IN THE AMAZON",
  letters: ["P", "I", "R", "A", "N", "A", "H"],
  word: "PIRANHA"
  }, {
  answer: "AARDVARK",
  hint: "NOCTURNAL ANTEATER FROM AFRICA",
  letters: ["A", "A", "R", "D", "V", "A", "K", "R"],
  word: "AARDVARK"
  }, {
  answer: "TREE",
  hint: "GREEN LUNGS OF EARTH",
  letters: ["T", "E", "R", "E"],
  word: "TREE"
  }, {
  answer: "FLAMINGO",
  hint: "PINK WADING BIRD",
  letters: ["F", "L", "A", "M", "I", "N", "O", "G"],
  word: "FLAMINGO"
  }, {
  answer: "BIRD",
  hint: "FLAPPING THROUGH THE BREEZE",
  letters: ["B", "I", "D", "R"],
  word: "BIRD"
  }, {
  answer: "ORCA",
  hint: "KILLER WHALE",
  letters: ["O", "R", "A", "C"],
  word: "ORCA"
  }, {
  answer: "MACAW",
  hint: "COLORFUL PARROT",
  letters: ["M", "A", "C", "W", "A"],
  word: "MACAW"
  }, {
  answer: "CANARY",
  hint: "YELLOW SINGING BIRD",
  letters: ["C", "A", "N", "A", "Y", "R"],
  word: "CANARY"
  }, {
  answer: "CHEETAH",
  hint: "FASTEST LAND ANIMAL",
  letters: ["C", "H", "E", "E", "T", "H", "A"],
  word: "CHEETAH"
  }, {
  answer: "GECKO",
  hint: "SMALL LIZARD THAT CAN CLIMB WALLS",
  letters: ["G", "E", "C", "O", "K"],
  word: "GECKO"
  }, {
  answer: "PANTHER",
  hint: "BIG CAT WITH DARK FUR",
  letters: ["P", "A", "N", "T", "H", "R", "E"],
  word: "PANTHER"
  }, {
  answer: "ANEMONE",
  hint: "MARINE ANIMAL WITH STINGING TENTACLES",
  letters: ["A", "N", "E", "M", "O", "E", "N"],
  word: "ANEMONE"
  }, {
  answer: "IBIS",
  hint: "WADING BIRD WITH LONG LEGS AND BEAK",
  letters: ["I", "B", "S", "I"],
  word: "IBIS"
  }, {
  answer: "ALGAE",
  hint: "PLANTLIKE ORGANISM IN WATER",
  letters: ["A", "L", "G", "E", "A"],
  word: "ALGAE"
  }, {
  answer: "FROG",
  hint: "AMPHIBIAN THAT JUMPS",
  letters: ["F", "R", "G", "O"],
  word: "FROG"
  }, {
  answer: "HERMIT",
  hint: "SOMEONE WHO LIVES ALONE",
  letters: ["H", "E", "R", "M", "T", "I"],
  word: "HERMIT"
  }, {
  answer: "HYDRA",
  hint: "MYTHICAL MULTI-HEADED SERPENT",
  letters: ["H", "Y", "D", "A", "R"],
  word: "HYDRA"
  }, {
  answer: "PANDA",
  hint: "BLACK AND WHITE BEAR",
  letters: ["P", "A", "N", "A", "D"],
  word: "PANDA"
  }, {
  answer: "MANTA RAY",
  hint: "LARGE FLAT FISH",
  letters: ["M", "A", "N", "T", "A", "R", "Y", "A"],
  word: "MANTA RAY"
  }, {
  answer: "DODO",
  hint: "EXTINCT FLIGHTLESS BIRD",
  letters: ["D", "O", "O", "D"],
  word: "DODO"
  }, {
  answer: "ANT",
  hint: "SMALL INSECT THAT LIVES IN COLONIES",
  letters: ["A", "T", "N"],
  word: "ANT"
  }, {
  answer: "GOPHER",
  hint: "BURROWING RODENT",
  letters: ["G", "O", "P", "H", "R", "E"],
  word: "GOPHER"
  }, {
  answer: "LOBSTER",
  hint: "SHELLFISH WITH LARGE CLAWS",
  letters: ["L", "O", "B", "S", "T", "R", "E"],
  word: "LOBSTER"
  }, {
  answer: "YAK",
  hint: "LARGE LONG HAIRED BOVINE",
  letters: ["Y", "K", "A"],
  word: "YAK"
  }, {
  answer: "CRANE",
  hint: "LARGE WADING BIRD",
  letters: ["C", "R", "A", "E", "N"],
  word: "CRANE"
  }, {
  answer: "PARROT",
  hint: "COLORFUL TALKATIVE BIRD",
  letters: ["P", "A", "R", "R", "T", "O"],
  word: "PARROT"
  }, {
  answer: "IBEX",
  hint: "WILD GOAT WITH CURVED HORNS",
  letters: ["I", "B", "X", "E"],
  word: "IBEX"
  }, {
  answer: "HAMSTER",
  hint: "SMALL RODENT KEPT AS A PET",
  letters: ["H", "A", "M", "S", "T", "R", "E"],
  word: "HAMSTER"
  }, {
  answer: "ANTELOPE",
  hint: "FAST-HOOFED MAMMAL",
  letters: ["A", "N", "T", "E", "L", "O", "E", "P"],
  word: "ANTELOPE"
  }, {
  answer: "STINGRAY",
  hint: "FLAT SEA CREATURE WITH A STINGER",
  letters: ["S", "T", "I", "N", "G", "R", "Y ", "A"],
  word: "STINGRAY"
  }, {
  answer: "CLOCK",
  hint: "TELLS TIME ON THE WALL",
  letters: ["C", "L", "O", "K", "C"],
  word: "CLOCK"
  }, {
  answer: "OTTER",
  hint: "PLAYFUL AQUATIC MAMMAL",
  letters: ["O", "T", "T", "R", "E"],
  word: "OTTER"
  }, {
  answer: "HYENA",
  hint: "CARNIVORE THAT LAUGHS",
  letters: ["H", "Y", "E", "A", "N"],
  word: "HYENA"
  }, {
  answer: "BEAVER",
  hint: "DAM BUILDING ANIMAL",
  letters: ["B", "E", "A", "V", "R", "E"],
  word: "BEAVER"
  }, {
  answer: "BAT",
  hint: "FLYING MAMMAL",
  letters: ["B", "T", "A"],
  word: "BAT"
  }, {
  answer: "STORK",
  hint: "LARGE BIRD KNOWN FOR DELIVERING BABIES IN FOLKLORE",
  letters: ["S", "T", "O", "K", "R"],
  word: "STORK"
  }, {
  answer: "MOLE",
  hint: "BURROWING MAMMAL",
  letters: ["M", "O", "E", "L"],
  word: "MOLE"
  }, {
  answer: "CRAB",
  hint: "CLAWED OCEAN DWELLER",
  letters: ["C", "R", "B", "A"],
  word: "CRAB"
  }, {
  answer: "PIRATE",
  hint: "SAILOR WHO PLUNDERS",
  letters: ["P", "I", "R", "A", "E", "T"],
  word: "PIRATE"
  }, {
  answer: "BALLOON",
  hint: "INFLATED CELEBRATION ITEM",
  letters: ["B", "A", "L", "L", "O", "N", "O"],
  word: "BALLOON"
  }, {
  answer: "GUPPY",
  hint: "SMALL TROPICAL FISH",
  letters: ["G", "U", "P", "Y", "P"],
  word: "GUPPY"
  }, {
  answer: "WOMBAT",
  hint: "AUSTRALIAN MARSUPIAL",
  letters: ["W", "O", "M", "B", "T", "A"],
  word: "WOMBAT"
  }, {
  answer: "MONGOOSE",
  hint: "SNAKE EATING MAMMAL",
  letters: ["M", "O", "N", "G", "O", "O", "E", "S"],
  word: "MONGOOSE"
  }, {
  answer: "COYOTE",
  hint: "WILD CANINE",
  letters: ["C", "O", "Y", "O", "E", "T"],
  word: "COYOTE"
  }, {
  answer: "MOUSE",
  hint: "SMALL RODENT",
  letters: ["M", "O", "U", "E", "S"],
  word: "MOUSE"
  }, {
  answer: "IGUANA",
  hint: "TROPICAL LIZARD",
  letters: ["I", "G", "U", "A", "A", "N"],
  word: "IGUANA"
  }, {
  answer: "ELEPHANT",
  hint: "MAJESTIC TRUNKED CREATURE",
  letters: ["E", "L", "E", "P", "H", "A", "T", "N"],
  word: "ELEPHANT"
  }, {
  answer: "COBRA",
  hint: "VENOMOUS SNAKE",
  letters: ["C", "O", "B", "A", "R"],
  word: "COBRA"
  }, {
  answer: "OSTRICH",
  hint: "LARGEST BIRD",
  letters: ["O", "S", "T", "R", "I", "H", "C"],
  word: "OSTRICH"
  }, {
  answer: "WAVES",
  hint: "MOVEMENTS IN WATER",
  letters: ["W", "A", "V", "S", "E"],
  word: "WAVES"
  }, {
  answer: "GRIZZLY",
  hint: "LARGE BEAR",
  letters: ["G", "R", "I", "Z", "Z", "Y", "L"],
  word: "GRIZZLY"
  }, {
  answer: "VULTURE",
  hint: "BIRD THAT FEEDS ON CARRION",
  letters: ["V", "U", "L", "T", "U", "E", "R"],
  word: "VULTURE"
  }, {
  answer: "PORPOISE",
  hint: "SMALL WHALE",
  letters: ["P", "O", "R", "P", "O", "I", "E", "S"],
  word: "PORPOISE"
  }, {
  answer: "ROSE",
  hint: "SYMBOL OF LOVE",
  letters: ["R", "O", "E", "S"],
  word: "ROSE"
  }, {
  answer: "PANDA",
  hint: "BAMBOO MUNCHER",
  letters: ["P", "A", "N", "A", "D"],
  word: "PANDA"
  }, {
  answer: "SQUID",
  hint: "MARINE CREATURE WITH TENTACLES",
  letters: ["S", "Q", "U", "D", "I"],
  word: "SQUID"
  }, {
  answer: "HAMMER",
  hint: "TOOL OF FORCE",
  letters: ["H", "A", "M", "M", "R", "E"],
  word: "HAMMER"
  }, {
  answer: "EAGLE",
  hint: "MAJESTIC SKY PREDATOR",
  letters: ["E", "A", "G", "E", "L"],
  word: "EAGLE"
  }, {
  answer: "SLOTH",
  hint: "VERY SLOW ANIMAL",
  letters: ["S", "L", "O", "H", "T"],
  word: "SLOTH"
  }, {
  answer: "SQUARE",
  hint: "FOUR EQUAL SIDES",
  letters: ["S", "Q", "U", "A", "E", "R"],
  word: "SQUARE"
  }, {
  answer: "BISON",
  hint: "LARGE HERBIVORE OF THE PLAINS",
  letters: ["B", "I", "S", "N", "O"],
  word: "BISON"
  }, {
  answer: "KOALA",
  hint: "CUDDLY ICON OF AUSTRALIA",
  letters: ["K", "O", "A", "A", "L"],
  word: "KOALA"
  }, {
  answer: "JAGUAR",
  hint: "BIG CAT WITH SPOTS",
  letters: ["J", "A", "G", "U", "R", "A"],
  word: "JAGUAR"
  }, {
  answer: "HERON",
  hint: "LONG LEGGED WADING BIRD",
  letters: ["H", "E", "R", "N", "O"],
  word: "HERON"
  }, {
  answer: "WALRUS",
  hint: "MARINE MAMMAL WITH TUSKS",
  letters: ["W", "A", "L", "R", "S", "U"],
  word: "WALRUS"
  }, {
  answer: "PANGOLIN",
  hint: "ARMOR PLATED MAMMAL",
  letters: ["P", "A", "N", "G", "O", "L", "N", "I"],
  word: "PANGOLIN"
  }, {
  answer: "DOLPHIN",
  hint: "FRIENDLY OCEAN MAMMAL",
  letters: ["D", "O", "L", "P", "H", "N", "I"],
  word: "DOLPHIN"
  }, {
  answer: "SNAKE",
  hint: "REPTILE THAT SLITHERS",
  letters: ["S", "N", "A", "E", "K"],
  word: "SNAKE"
  }, {
  answer: "CARROT",
  hint: "CRUNCHY ORANGE VEGETABLE",
  letters: ["C", "A", "R", "R", "T", "O"],
  word: "CARROT"
  }, {
  answer: "WHALE",
  hint: "LARGEST MARINE MAMMAL",
  letters: ["W", "H", "A", "E", "L"],
  word: "WHALE"
  }, {
  answer: "KEY",
  hint: "USED TO UNLOCK DOORS",
  letters: ["K", "Y", "E"],
  word: "KEY"
  }, {
  answer: "PUMA",
  hint: "LARGE WILD CAT ALSO KNOWN AS A COUGAR",
  letters: ["P", "U", "A", "M"],
  word: "PUMA"
  }, {
  answer: "PELICAN",
  hint: "WATER BIRD WITH A LARGE BEAK",
  letters: ["P", "E", "L", "I", "C", "N", "A"],
  word: "PELICAN"
  }, {
  answer: "WINTER",
  hint: "SEASON OF ICE AND SNOW",
  letters: ["W", "I", "N", "T", "R", "E"],
  word: "WINTER"
  }, {
  answer: "SUMMER",
  hint: "HOT DAYS AND SUNNY RAYS",
  letters: ["S", "U", "M", "M", "R", "E"],
  word: "SUMMER"
  }, {
  answer: "AUTUMN",
  hint: "SEASON OF FALLING LEAVES",
  letters: ["A", "U", "T", "U", "N", "M"],
  word: "AUTUMN"
  }, {
  answer: "OCTOPUS",
  hint: "SEA CREATURE WITH EIGHT ARMS",
  letters: ["O", "C", "T", "O", "P", "S", "U"],
  word: "OCTOPUS"
  }, {
  answer: "PENGUIN",
  hint: "ANTARCTIC BIRD",
  letters: ["P", "E", "N", "G", "U", "N", "I"],
  word: "PENGUIN"
  }, {
  answer: "LION",
  hint: "KING OF THE JUNGLE",
  letters: ["L", "I", "N", "O"],
  word: "LION"
  }, {
  answer: "TURTLE",
  hint: "REPTILE WITH A HARD SHELL",
  letters: ["T", "U", "R", "T", "E", "L"],
  word: "TURTLE"
  }, {
  answer: "LIONFISH",
  hint: "VENOMOUS MARINE FISH",
  letters: ["L", "I", "O", "N", "F", "I", "H", "S"],
  word: "LIONFISH"
  }, {
  answer: "MOOSE",
  hint: "LARGE ANTLERED ANIMAL",
  letters: ["M", "O", "O", "E", "S"],
  word: "MOOSE"
  }, {
  answer: "BEE",
  hint: "INSECT THAT MAKES HONEY",
  letters: ["E", "B", "E"],
  word: "BEE"
  }, {
  answer: "LEMUR",
  hint: "PRIMATE FROM MADAGASCAR",
  letters: ["L", "E", "M", "R", "U"],
  word: "LEMUR"
  }, {
  answer: "EMERALD",
  hint: "GREEN GEMSTONE",
  letters: ["E", "M", "E", "R", "A", "D", "L"],
  word: "EMERALD"
  }, {
  answer: "TURKEY",
  hint: "BIRD COMMONLY EATEN ON THANKSGIVING",
  letters: ["T", "U", "R", "K", "Y", "E"],
  word: "TURKEY"
  }, {
  answer: "OCELOT",
  hint: "SMALL WILD CAT",
  letters: ["O", "C", "E", "L", "T", "O"],
  word: "OCELOT"
  }, {
  answer: "FALCON",
  hint: "BIRD OF PREY KNOWN FOR SPEED",
  letters: ["F", "A", "L", "C", "N", "O"],
  word: "FALCON"
  }, {
  answer: "QUOKKA",
  hint: "SMALL MARSUPIAL KNOWN FOR SMILING",
  letters: ["O", "U", "Q", "K", "A", "K"],
  word: "QUOKKA"
  }, {
  answer: "GIRAFFE",
  hint: "ANIMAL WITH A LONG NECK",
  letters: ["R", "I", "G", "A", "F", "E", "F"],
  word: "GIRAFFE"
  }, {
  answer: "PLANET",
  hint: "PART OF THE SOLAR SYSTEM",
  letters: ["A", "L", "P", "N", "T", "E"],
  word: "PLANET"
  }, {
  answer: "EARTH",
  hint: "HOME TO ALL LIFE",
  letters: ["R", "A", "E", "H", "T"],
  word: "EARTH"
  }, {
  answer: "RABBIT",
  hint: "CARROT LOVING ANIMAL",
  letters: ["B", "A", "R", "B", "T", "I"],
  word: "RABBIT"
  }, {
  answer: "COMPUTER",
  hint: "ELECTRONIC DEVICE",
  letters: ["P", "O", "M", "C", "U", "T", "R", "E"],
  word: "COMPUTER"
  }, {
  answer: "LIBRARY",
  hint: "PLACE TO BORROW BOOKS",
  letters: ["B", "I", "L", "R", "A", "Y", "R"],
  word: "LIBRARY"
  }, {
  answer: "MELON",
  hint: "JUICY FRUIT WITH A SWEET FLAVOR",
  letters: ["E", "M", "L", "N", "O"],
  word: "MELON"
  }, {
  answer: "ECLIPSE",
  hint: "OBSCURING OF LIGHT FROM A BODY",
  letters: ["C", "E", "L", "I", "P", "E", "S"],
  word: "ECLIPSE"
  }, {
  answer: "SHADOW",
  hint: "DARK FORM CREATED BY BLOCKED LIGHT",
  letters: ["H", "S", "A", "D", "W", "O"],
  word: "SHADOW"
  }, {
  answer: "DESERT",
  hint: "ARID AREA WITH LITTLE WATER OR PLANT LIFE",
  letters: ["E", "D", "S", "E", "T", "R"],
  word: "DESERT"
  }, {
  answer: "TROPHY",
  hint: "AWARD GIVEN FOR WINNING A COMPETITION",
  letters: ["R", "T", "O", "P", "Y", "H"],
  word: "TROPHY"
  }, {
  answer: "GLOVES",
  hint: "HAND WEAR FOR COLD WEATHER",
  letters: ["O", "L", "G", "V", "S", "E"],
  word: "GLOVES"
  }, {
  answer: "KEYBOARD",
  hint: "MUSICAL INSTRUMENT WITH KEYS",
  letters: ["Y", "E", "K", "B", "O", "A", "D", "R"],
  word: "KEYBOARD"
  }, {
  answer: "MAGNET",
  hint: "ATTRACTS METAL OBJECTS",
  letters: ["G", "A", "M", "N", "T", "E"],
  word: "MAGNET"
  }, {
  answer: "STORM",
  hint: "A VIOLENT WEATHER EVENT",
  letters: ["O", "T", "S", "M", "R"],
  word: "STORM"
  }, {
  answer: "CHAIR",
  hint: "FURNITURE USED TO SIT ON",
  letters: ["H", "A", "C", "R", "I"],
  word: "CHAIR"
  }, {
  answer: "PENCIL",
  hint: "A TOOL USED FOR WRITING OR DRAWING",
  letters: ["P", "E", "N", "C", "L", "I"],
  word: "PENCIL"
  }, {
  answer: "LAPTOP",
  hint: "PORTABLE COMPUTER",
  letters: ["P", "A", "L", "T", "P", "O"],
  word: "LAPTOP"
  }, {
  answer: "BRUSH",
  hint: "TOOL USED FOR CLEANING",
  letters: ["R", "U", "B", "H", "S"],
  word: "BRUSH"
  }, {
  answer: "FLOOR",
  hint: "THE SURFACE YOU WALK ON",
  letters: ["L", "F", "O", "R", "O"],
  word: "FLOOR"
  }, {
  answer: "PEACE",
  hint: "A STATE OF CALM AND HARMONY",
  letters: ["A", "P", "E", "E", "C"],
  word: "PEACE"
  }, {
  answer: "TABLE",
  hint: "FURNITURE WITH A FLAT SURFACE",
  letters: ["B", "A", "T", "E", "L"],
  word: "TABLE"
  }, {
  answer: "SHOE",
  hint: "FOOTWEAR",
  letters: ["H", "S", "E", "O"],
  word: "SHOE"
  }, {
  answer: "MOON",
  hint: "EARTH'S NATURAL SATELLITE",
  letters: ["O", "O", "N", "M"],
  word: "MOON"
  }, {
  answer: "BRICK",
  hint: "A RECTANGULAR PIECE OF HARD MATERIAL",
  letters: ["C", "R", "I", "K", "B"],
  word: "BRICK"
  }, {
  answer: "RAIN",
  hint: "WATER FALLING FROM THE SKY",
  letters: ["I", "N", "A", "R"],
  word: "RAIN"
  }, {
  answer: "BOOK",
  hint: "A COLLECTION OF PAGES",
  letters: ["O", "O", "K", "B"],
  word: "BOOK"
  }, {
  answer: "DOG",
  hint: "A COMMON PET",
  letters: ["O", "G", "D"],
  word: "DOG"
  }, {
  answer: "CUP",
  hint: "A SMALL CONTAINER FOR DRINKS",
  letters: ["U", "P", "C"],
  word: "CUP"
  }, {
  answer: "STAR",
  hint: "A BRIGHT OBJECT IN THE SKY",
  letters: ["A", "T", "R", "S"],
  word: "STAR"
  }, {
  answer: "SOCK",
  hint: "A PIECE OF CLOTHING FOR THE FEET",
  letters: ["K", "S", "O", "C"],
  word: "SOCK"
  }, {
  answer: "SUN",
  hint: "THE STAR AT THE CENTER OF OUR SOLAR SYSTEM",
  letters: ["U", "N", "S"],
  word: "SUN"
  }, {
  answer: "CAR",
  hint: "A VEHICLE WITH FOUR WHEELS",
  letters: ["A", "R", "C"],
  word: "CAR"
  }, {
  answer: "BALL",
  hint: "A ROUND OBJECT USED IN SPORTS",
  letters: ["A", "L", "B", "L"],
  word: "BALL"
  }, {
  answer: "RIVER",
  hint: "A NATURAL FLOW OF WATER",
  letters: ["V", "R", "I", "R", "E"],
  word: "RIVER"
  }, {
  answer: "FORK",
  hint: "A TOOL WITH PRONGS USED TO EAT",
  letters: ["O", "F", "K", "R"],
  word: "FORK"
  }, {
  answer: "PAPER",
  hint: "A FLAT MATERIAL USED FOR WRITING",
  letters: ["A", "P", "P", "R", "E"],
  word: "PAPER"
  }, {
  answer: "FISH",
  hint: "A WATER DWELLING CREATURE",
  letters: ["I", "F", "H", "S"],
  word: "FISH"
  }, {
  answer: "WATER",
  hint: "A COLORLESS LIQUID ESSENTIAL FOR LIFE",
  letters: ["W", "T", "R", "A", "E"],
  word: "WATER"
  }, {
  answer: "LAMP",
  hint: "A DEVICE THAT PROVIDES LIGHT",
  letters: ["A", "L", "P", "M"],
  word: "LAMP"
  }, {
  answer: "BRAIN",
  hint: "THE ORGAN THAT CONTROLS THOUGHTS",
  letters: ["R", "B", "A", "N", "I"],
  word: "BRAIN"
  }, {
  answer: "PAINT",
  hint: "A SUBSTANCE USED FOR COVERING SURFACES",
  letters: ["A", "I", "P", "T", "N"],
  word: "PAINT"
  }, {
  answer: "COIN",
  hint: "A SMALL METAL CURRENCY",
  letters: ["O", "N", "C", "I"],
  word: "COIN"
  }, {
  answer: "CAT",
  hint: "A DOMESTICATED PET KNOWN FOR ITS INDEPENDENCE",
  letters: ["A", "T", "C"],
  word: "CAT"
  }, {
  answer: "SALT",
  hint: "MINERAL USED IN COOKING",
  letters: ["T", "S", "A", "L"],
  word: "SALT"
  }, {
  answer: "PLANT",
  hint: "USES SUNLIGHT TO MAKE FOOD",
  letters: ["L", "A", "P", "T", "N"],
  word: "PLANT"
  }, {
  answer: "BEACH",
  hint: "A SHORELINE AREA WITH SAND AND WATER",
  letters: ["A", "B", "E", "H", "C"],
  word: "BEACH"
  }, {
  answer: "MUSIC",
  hint: "A FORM OF ARTISTIC EXPRESSION USING SOUND",
  letters: ["U", "M", "C", "I", "S"],
  word: "MUSIC"
  }, {
  answer: "FIGHT",
  hint: "A CONFLICT BETWEEN TWO OR MORE PARTIES",
  letters: ["G", "F", "I", "T", "H"],
  word: "FIGHT"
  }, {
  answer: "STONE",
  hint: "HARD MINERAL MATERIAL FOUND IN THE EARTH",
  letters: ["O", "T", "S", "E", "N"],
  word: "STONE"
  }, {
  answer: "HORSE",
  hint: "A LARGE ANIMAL USED FOR RIDING",
  letters: ["O", "R", "H", "E", "S"],
  word: "HORSE"
  }, {
  answer: "SHAPE",
  hint: "THE FORM OF AN OBJECT OR AREA",
  letters: ["H", "A", "S", "E", "P"],
  word: "SHAPE"
  }, {
  answer: "TIME",
  hint: "MEASURED IN HOURS AND MINUTES",
  letters: ["I", "T", "E", "M"],
  word: "TIME"
  }, {
  answer: "FOOD",
  hint: "ESSENTIAL FOR SURVIVAL",
  letters: ["D", "O", "F", "O"],
  word: "FOOD"
  }, {
  answer: "ROAD",
  hint: "A PATH FOR VEHICLES",
  letters: ["D", "A", "R", "O"],
  word: "ROAD"
  }, {
  answer: "SOIL",
  hint: "THE EARTH IN WHICH PLANTS GROW",
  letters: ["L", "O", "S", "I"],
  word: "SOIL"
  }, {
  answer: "WIND",
  hint: "FELT BUT NOT HELD",
  letters: ["D", "I", "W", "N"],
  word: "WIND"
  }, {
  answer: "HAND",
  hint: "A PART OF THE BODY USED FOR GRASPING",
  letters: ["D", "A", "H", "N"],
  word: "HAND"
  }, {
  answer: "PARK",
  hint: "A PUBLIC AREA FOR RECREATION",
  letters: ["K", "R", "P", "A"],
  word: "PARK"
  }, {
  answer: "MOUNTAIN",
  hint: "A PEAK OR HIGH LAND FORMATION",
  letters: ["N", "O", "U", "M", "T", "N", "I", "A"],
  word: "MOUNTAIN"
  }, {
  answer: "SINK",
  hint: "TO GO DOWN BELOW THE SURFACE",
  letters: ["K", "I", "S", "N"],
  word: "SINK"
  }, {
  answer: "TUNA",
  hint: "A LARGE FISH FOUND IN THE OCEAN",
  letters: ["A", "U", "T", "N"],
  word: "TUNA"
  }, {
  answer: "GLOW",
  hint: "TO EMIT A SOFT LIGHT",
  letters: ["W", "L", "G", "O"],
  word: "GLOW"
  }, {
  answer: "BELL",
  hint: "A METAL OBJECT THAT RINGS WHEN STRUCK",
  letters: ["E", "L", "B", "L"],
  word: "BELL"
  }, {
  answer: "PEAR",
  hint: "A FRUIT WITH A ROUND BASE AND NARROW TOP",
  letters: ["R", "E", "P", "A"],
  word: "PEAR"
  }, {
  answer: "WALL",
  hint: "A VERTICAL SURFACE THAT DIVIDES SPACES",
  letters: ["A", "L", "W", "L"],
  word: "WALL"
  }, {
  answer: "JUMP",
  hint: "TO LEAP INTO THE AIR",
  letters: ["M", "U", "P", "J"],
  word: "JUMP"
  }, {
  answer: "SOIL",
  hint: "TOP LAYER OF EARTH WHERE PLANTS GROW",
  letters: ["L", "O", "S", "I"],
  word: "SOIL"
  }, {
  answer: "GARDEN",
  hint: "A PLOT OF LAND WHERE PLANTS GROW",
  letters: ["R", "A", "G", "D", "N", "E"],
  word: "GARDEN"
  }, {
  answer: "FAMILY",
  hint: "A GROUP OF PEOPLE RELATED BY BLOOD",
  letters: ["M", "A", "I", "F", "Y", "L"],
  word: "FAMILY"
  }, {
  answer: "MOUNT",
  hint: "TO RAISE OR LIFT SOMETHING UP",
  letters: ["U", "O", "M", "T", "N"],
  word: "MOUNT"
  }, {
  answer: "ANIMAL",
  hint: "A LIVING CREATURE THAT IS NOT A PLANT",
  letters: ["N", "I", "A", "M", "L", "A"],
  word: "ANIMAL"
  }, {
  answer: "SINGER",
  hint: "SOMEONE WHO SINGS",
  letters: ["I", "N", "S", "G", "R", "E"],
  word: "SINGER"
  }, {
  answer: "CIRCLE",
  hint: "A ROUND SHAPE",
  letters: ["I", "C", "R", "C", "E", "L"],
  word: "CIRCLE"
  }, {
  answer: "COFFEE",
  hint: "A BEVERAGE MADE FROM ROASTED BEANS",
  letters: ["E", "O", "F", "C", "F", "E"],
  word: "COFFEE"
  }, {
  answer: "BRAINY",
  hint: "HAVING INTELLIGENCE",
  letters: ["I", "R", "A", "B", "Y", "N"],
  word: "BRAINY"
  }, {
  answer: "TUNING",
  hint: "ADJUSTING A MUSICAL INSTRUMENT",
  letters: ["N", "U", "T", "I", "G", "N"],
  word: "TUNING"
  }, {
  answer: "FOLDER",
  hint: "A CONTAINER FOR STORING PAPERS",
  letters: ["L", "O", "F", "D", "R", "E"],
  word: "FOLDER"
  }, {
  answer: "STITCH",
  hint: "A LOOPED SEAM IN TEXTILES",
  letters: ["I", "T", "S", "T", "H", "C"],
  word: "STITCH"
  }, {
  answer: "RANGER",
  hint: "A PERSON WHO PROTECTS WILDERNESS",
  letters: ["N", "A", "R", "G", "R", "E"],
  word: "RANGER"
  }, {
  answer: "GRAPES",
  hint: "USED TO MAKE WINE",
  letters: ["R", "G", "S", "E", "P", "A"],
  word: "GRAPES"
  }, {
  answer: "NOTIFY",
  hint: "TO INFORM SOMEONE",
  letters: ["T", "O", "N", "I", "Y", "F"],
  word: "NOTIFY"
  }, {
  answer: "TETHER",
  hint: "TO ATTACH WITH A ROPE OR CHAIN",
  letters: ["E", "T", "H", "T", "R", "E"],
  word: "TETHER"
  }, {
  answer: "CLOSET",
  hint: "A SMALL ROOM FOR STORAGE",
  letters: ["L", "O", "C", "S", "T", "E"],
  word: "CLOSET"
  }, {
  answer: "BANNER",
  hint: "USED FOR ADVERTISING OR PROMOTION",
  letters: ["A", "N", "B", "N", "R", "E"],
  word: "BANNER"
  }, {
  answer: "TROOPS",
  hint: "GROUPS OF SOLDIERS",
  letters: ["O", "R", "O", "T", "S", "P"],
  word: "TROOPS"
  }, {
  answer: "TICKET",
  hint: "A PASS FOR ENTRY",
  letters: ["K", "I", "C", "T", "T", "E"],
  word: "TICKET"
  }, {
  answer: "LISTEN",
  hint: "TO PAY ATTENTION WITH YOUR EARS",
  letters: ["T", "I", "S", "L", "N", "E"],
  word: "LISTEN"
  }, {
  answer: "STRONG",
  hint: "HAVING GREAT PHYSICAL OR MENTAL POWER",
  letters: ["G", "R", "T", "O", "S", "N"],
  word: "STRONG"
  }, {
  answer: "MARKER",
  hint: "A WRITING TOOL USED FOR MAKING MARKS",
  letters: ["K", "R", "A", "M", "R", "E"],
  word: "MARKER"
  }, {
  answer: "FAMOUS",
  hint: "WELL-KNOWN OR CELEBRATED",
  letters: ["O", "A", "M", "F", "S", "U"],
  word: "FAMOUS"
  }, {
  answer: "BUTTON",
  hint: "A SMALL OBJECT USED TO FASTEN CLOTHING",
  letters: ["N", "T", "U", "T", "B", "O"],
  word: "BUTTON"
  }, {
  answer: "POCKET",
  hint: "USED TO CARRY SMALL ESSENTIALS",
  letters: ["K", "O", "C", "P", "T", "E"],
  word: "POCKET"
  }, {
  answer: "SILENT",
  hint: "NOT MAKING ANY SOUND",
  letters: ["N", "I", "L", "E", "T", "S"],
  word: "SILENT"
  }, {
  answer: "MEDAL",
  hint: "A REWARD FOR ACHIEVEMENT",
  letters: ["L", "E", "M", "A", "D"],
  word: "MEDAL"
  }, {
  answer: "THRILL",
  hint: "A SUDDEN SHOCKING FEELING",
  letters: ["R", "H", "T", "L", "I", "L"],
  word: "THRILL"
  }, {
  answer: "STUDENT",
  hint: "A LEARNER IN ANY FIELD",
  letters: ["T", "U", "T", "S", "N", "E", "D"],
  word: "STUDENT"
  }, {
  answer: "BAKER",
  hint: "A PERSON WHO MAKES BREAD AND CAKES",
  letters: ["K", "A", "B", "R", "E"],
  word: "BAKER"
  }, {
  answer: "STREET",
  hint: "A PAVED ROAD IN A CITY OR TOWN",
  letters: ["R", "T", "S", "E", "T", "E"],
  word: "STREET"
  }, {
  answer: "JACKET",
  hint: "A WARM OUTER GARMENT",
  letters: ["T", "A", "C", "J", "K", "E"],
  word: "JACKET"
  }, {
  answer: "MOTHER",
  hint: "A FEMALE PARENT",
  letters: ["R", "T", "O", "H", "M", "E"],
  word: "MOTHER"
  }, {
  answer: "PACKAGE",
  hint: "A BOX OR PARCEL FOR DELIVERY",
  letters: ["G", "A", "C", "K", "E", "P", "A"],
  word: "PACKAGE"
  }, {
  answer: "COMPUTE",
  hint: "TO CALCULATE OR PROCESS INFORMATION",
  letters: ["E", "O", "M", "P", "U", "C", "T"],
  word: "COMPUTE"
  }, {
  answer: "FRIENDS",
  hint: "STAND BY YOU IN GOOD AND BAD TIMES",
  letters: ["S", "I", "R", "N", "E", "F", "D"],
  word: "FRIENDS"
  }, {
  answer: "JOURNEY",
  hint: "A TRIP OR ADVENTURE",
  letters: ["Y", "O", "U", "R", "J", "E", "N"],
  word: "JOURNEY"
  }, {
  answer: "DOUBLE",
  hint: "TWICE THE AMOUNT OR SIZE",
  letters: ["U", "O", "B", "D", "E", "L"],
  word: "DOUBLE"
  }, {
  answer: "CRACK",
  hint: "A SPLIT IN THE SURFACE",
  letters: ["A", "R", "C", "C", "K"],
  word: "CRACK"
  }, {
  answer: "EXAMPLE",
  hint: "A REPRESENTATION THAT ILLUSTRATES A POINT",
  letters: ["P", "X", "M", "A", "E", "E", "L"],
  word: "EXAMPLE"
  }, {
  answer: "SUCCESS",
  hint: "ACHIEVEMENT OF A GOAL OR OBJECTIVE",
  letters: ["C", "U", "S", "C", "S", "E", "S"],
  word: "SUCCESS"
  }, {
  answer: "CAPITAL",
  hint: "A CITY THAT IS THE GOVT SEAT OF A COUNTRY",
  letters: ["P", "A", "C", "I", "T", "L", "A"],
  word: "CAPITAL"
  }, {
  answer: "TEACHER",
  hint: "SOMEONE WHO EDUCATES STUDENTS",
  letters: ["H", "E", "A", "T", "C", "R", "E"],
  word: "TEACHER"
  }, {
  answer: "PRESENT",
  hint: "A GIFT GIVEN TO SOMEONE",
  letters: ["S", "R", "E", "P", "E", "T", "N"],
  word: "PRESENT"
  }, {
  answer: "RESEARCH",
  hint: "DETAILED STUDY OR INVESTIGATION",
  letters: ["A", "E", "E", "S", "R", "R", "H", "C"],
  word: "RESEARCH"
  }, {
  answer: "COUNTRY",
  hint: "HAS BORDERS AND A FLAG",
  letters: ["R", "O", "U", "N", "Y", "C", "T"],
  word: "COUNTRY"
  }, {
  answer: "GALLERY",
  hint: "A PLACE WHERE ARTWORK IS DISPLAYED",
  letters: ["L", "L", "A", "G", "E", "Y", "R"],
  word: "GALLERY"
  }, {
  answer: "NOUN",
  hint: "A BASIC GRAMMAR TERM",
  letters: ["U", "O", "N", "N"],
  word: "NOUN"
  }, {
  answer: "BRIDGE",
  hint: "STRUCTURE BUILT TO CROSS WATER",
  letters: ["D", "R", "I", "B", "E", "G"],
  word: "BRIDGE"
  }, {
  answer: "EASY",
  hint: "SIMPLE OR COMFORTABLE",
  letters: ["A", "E", "Y", "S"],
  word: "EASY"
  }, {
  answer: "BROWSER",
  hint: "ALLOWS YOU TO VIEW WEBSITES",
  letters: ["W", "R", "O", "B", "R", "E", "S"],
  word: "BROWSER"
  }, {
  answer: "SERVER",
  hint: "PROVIDES RESOURCES TO OTHER COMPUTERS",
  letters: ["R", "E", "S", "V", "R", "E"],
  word: "SERVER"
  }, {
  answer: "WEBPAGE",
  hint: "A SINGLE DOCUMENT ON THE WORLD WIDE WEB",
  letters: ["B", "E", "W", "A", "P", "E", "G"],
  word: "WEBPAGE"
  }, {
  answer: "NETWORK",
  hint: "A SYSTEM OF CONNECTED DEVICES",
  letters: ["T", "E", "N", "W", "O", "K", "R"],
  word: "NETWORK"
  }, {
  answer: "UPLOAD",
  hint: "SENDING FILES TO A SERVER",
  letters: ["P", "U", "L", "D", "O", "A"],
  word: "UPLOAD"
  }, {
  answer: "DOWNLOAD",
  hint: "TO RECEIVE DATA FROM THE INTERNET",
  letters: ["N", "O", "D", "W", "L", "D", "O", "A"],
  word: "DOWNLOAD"
  }, {
  answer: "DOMAIN",
  hint: "A NAME THAT IDENTIFIES A WEBSITE",
  letters: ["D", "O", "M", "N", "I", "A"],
  word: "DOMAIN"
  }, {
  answer: "LINKS",
  hint: "CONNECTIONS TO ONLINE CONTENT",
  letters: ["N", "I", "L", "S", "K"],
  word: "LINKS"
  }, {
  answer: "EMAIL",
  hint: "A SYSTEM FOR SENDING MESSAGES ELECTRONICALLY",
  letters: ["M", "A", "E", "L", "I"],
  word: "EMAIL"
  }, {
  answer: "WILDLIFE",
  hint: "ANIMALS AND PLANTS LIVING IN THE FOREST ENVIRONMENT",
  letters: ["L", "I", "D", "W", "L", "I", "E", "F"],
  word: "WILDLIFE"
  }, {
  answer: "CANOPY",
  hint: "THE UPPER LAYER OF LEAVES IN A FOREST",
  letters: ["N", "A", "C", "O", "Y", "P"],
  word: "CANOPY"
  }, {
  answer: "BRANCH",
  hint: "HOLDS LEAVES, FRUIT, AND FLOWERS",
  letters: ["N", "R", "A", "B", "H", "C"],
  word: "BRANCH"
  }, {
  answer: "FOLIAGE",
  hint: "LEAVES OF PLANTS OR TREES",
  letters: ["I", "O", "L", "F", "A", "E", "G"],
  word: "FOLIAGE"
  }, {
  answer: "MOSS",
  hint: "A SMALL PLANT THAT GROWS IN FOREST MOISTURE",
  letters: ["O", "S", "M", "S"],
  word: "MOSS"
  }, {
  answer: "BARK",
  hint: "THE OUTER LAYER OF A TREE",
  letters: ["R", "A", "K", "B"],
  word: "BARK"
  }, {
  answer: "BED",
  hint: "A PIECE OF FURNITURE FOR SLEEPING",
  letters: ["E", "D", "B"],
  word: "BED"
  }, {
  answer: "SOFA",
  hint: "A LONG PIECE OF FURNITURE FOR SITTING",
  letters: ["F", "O", "A", "S"],
  word: "SOFA"
  }, {
  answer: "FRIDGE",
  hint: "KEEPS FOOD COLD",
  letters: ["G", "I", "R", "D", "E", "F"],
  word: "FRIDGE"
  }, {
  answer: "STOVE",
  hint: "A HOUSEHOLD APPLIANCE USED FOR COOKING",
  letters: ["T", "O", "S", "E", "V"],
  word: "STOVE"
  }, {
  answer: "RUG",
  hint: "A PIECE OF CARPET USED ON THE FLOOR",
  letters: ["U", "G", "R"],
  word: "RUG"
  }, {
  answer: "MOP",
  hint: "A TOOL FOR CLEANING FLOORS",
  letters: ["O", "P", "M"],
  word: "MOP"
  }, {
  answer: "BLENDER",
  hint: "A KITCHEN APPLIANCE USED TO MIX INGREDIENTS",
  letters: ["D", "L", "E", "N", "B", "R", "E"],
  word: "BLENDER"
  }, {
  answer: "VACUUM",
  hint: "A CLEANING DEVICE THAT SUCKS UP DIRT",
  letters: ["A", "V", "C", "U", "M", "U"],
  word: "VACUUM"
  }, {
  answer: "LADLE",
  hint: "A LONG HANDLED SPOON USED TO SERVE SOUPS",
  letters: ["A", "L", "D", "E", "L"],
  word: "LADLE"
  }, {
  answer: "TOWEL",
  hint: "A PIECE OF CLOTH USED TO DRY OBJECTS",
  letters: ["O", "T", "W", "L", "E"],
  word: "TOWEL"
  }, {
  answer: "PILLOW",
  hint: "A SOFT SUPPORT FOR THE HEAD WHILE SLEEPING",
  letters: ["L", "I", "P", "L", "W", "O"],
  word: "PILLOW"
  }, {
  answer: "CUPBOARD",
  hint: "A CABINET USED FOR STORING CLOTHING",
  letters: ["P", "U", "C", "B", "A", "O", "D", "R"],
  word: "CUPBOARD"
  }, {
  answer: "GALAXY",
  hint: "A SYSTEM OF STARS, DUST, AND GAS",
  letters: ["A", "G", "L", "A", "Y", "X"],
  word: "GALAXY"
  }, {
  answer: "COMET",
  hint: "A SMALL BODY OF ICE AND DUST IN SPACE",
  letters: ["M", "O", "C", "T", "E"],
  word: "COMET"
  }, {
  answer: "ASTEROID",
  hint: "A SMALL ROCKY BODY THAT ORBITS THE SUN",
  letters: ["E", "S", "T", "A", "R", "O", "D", "I"],
  word: "ASTEROID"
  }, {
  answer: "ORBIT",
  hint: "A CIRCULAR TRAJECTORY IN SPACE",
  letters: ["B", "R", "O", "T", "I"],
  word: "ORBIT"
  }, {
  answer: "NECKLACE",
  hint: "A PIECE OF JEWELRY WORN AROUND THE NECK",
  letters: ["C", "E", "N", "K", "L", "A", "E", "C"],
  word: "NECKLACE"
  }, {
  answer: "BRACELET",
  hint: "A BAND WORN AROUND THE WRIST",
  letters: ["C", "R", "A", "B", "E", "L", "T", "E"],
  word: "BRACELET"
  }, {
  answer: "EARRINGS",
  hint: "JEWELRY WORN ON THE EARS",
  letters: ["R", "R", "A", "E", "I", "N", "S", "G"],
  word: "EARRINGS"
  }, {
  answer: "SCARF",
  hint: "A PIECE OF CLOTH WORN IN COLD WEATHER",
  letters: ["C", "A", "S", "F", "R"],
  word: "SCARF"
  }, {
  answer: "HAT",
  hint: "A HEADPIECE WORN FOR STYLE OR PROTECTION",
  letters: ["A", "T", "H"],
  word: "HAT"
  }, {
  answer: "BAG",
  hint: "USED TO CARRY THINGS",
  letters: ["A", "G", "B"],
  word: "BAG"
  }, {
  answer: "BELT",
  hint: "WORN AROUND THE WAIST",
  letters: ["L", "E", "T", "B"],
  word: "BELT"
  }, {
  answer: "SUNGLASS",
  hint: "PROTECTS EYES FROM SUNLIGHT",
  letters: ["U", "S", "N", "L", "G", "S", "A", "S"],
  word: "SUNGLASS"
  }, {
  answer: "BURGER",
  hint: "A SANDWICH CONSISTING OF A PATTY AND BUN",
  letters: ["U", "B", "R", "G", "R", "E"],
  word: "BURGER"
  }, {
  answer: "PASTA",
  hint: "ITALIAN DISH MADE FROM WHEAT FLOUR AND WATER",
  letters: ["A", "P", "S", "A", "T"],
  word: "PASTA"
  }, {
  answer: "SUSHI",
  hint: "JAPANESE DISH MADE OF RICE, FISH, AND VEGETABLES",
  letters: ["I", "U", "S", "S", "H"],
  word: "SUSHI"
  }, {
  answer: "TACO",
  hint: "A MEXICAN DISH CONSISTING OF A FILLING IN A TORTILLA",
  letters: ["C", "A", "O", "T"],
  word: "TACO"
  }, {
  answer: "SALAD",
  hint: "A MIXTURE OF RAW VEGETABLES, USUALLY EATEN COLD",
  letters: ["L", "A", "S", "D", "A"],
  word: "SALAD"
  }, {
  answer: "SOUP",
  hint: "A LIQUID DISH, OFTEN EATEN HOT",
  letters: ["U", "O", "P", "S"],
  word: "SOUP"
  }, {
  answer: "CUPCAKE",
  hint: "A SWEET TREAT FOR PARTIES",
  letters: ["P", "U", "C", "C", "A", "E", "K"],
  word: "CUPCAKE"
  }, {
  answer: "DUMBBELL",
  hint: "A HANDHELD WEIGHT FOR EXERCISE",
  letters: ["M", "U", "D", "B", "B", "L", "E", "L"],
  word: "DUMBBELL"
  }, {
  answer: "SPIDER",
  hint: "EIGHT LEGGED WEB SPINNER",
  letters: ["P", "I", "S", "D", "R", "E"],
  word: "SPIDER"
  }, {
  answer: "CARDIO",
  hint: "EXERCISE THAT INCREASES THE HEART RATE",
  letters: ["R", "A", "C", "D", "O", "I"],
  word: "CARDIO"
  }, {
  answer: "SQUAT",
  hint: "A LOWER BODY EXERCISE",
  letters: ["U", "Q", "S", "T", "A"],
  word: "SQUAT"
  }, {
  answer: "PLANK",
  hint: "EXERCISE IN THE PUSH-UP POSITION",
  letters: ["L", "P", "A", "K", "N"],
  word: "PLANK"
  }, {
  answer: "YOGA",
  hint: "A MIND-BODY PRACTICE THAT INCLUDES MEDITATION",
  letters: ["O", "Y", "A", "G"],
  word: "YOGA"
  }, {
  answer: "TEXTBOOK",
  hint: "SOURCE OF LEARNING MATERIAL",
  letters: ["B", "X", "E", "T", "T", "O", "K", "O"],
  word: "TEXTBOOK"
  }, {
  answer: "DIARY",
  hint: "A DAILY PERSONAL RECORD",
  letters: ["Y", "I", "D", "R", "A"],
  word: "DIARY"
  }, {
  answer: "HOMEWORK",
  hint: "WORK YOU DO AFTER SCHOOL HOURS",
  letters: ["O", "E", "M", "H", "O", "W", "K", "R"],
  word: "HOMEWORK"
  }, {
  answer: "BOARD",
  hint: "USED IN CLASSROOMS AND MEETINGS",
  letters: ["A", "O", "B", "D", "R"],
  word: "BOARD"
  }, {
  answer: "GRADE",
  hint: "A RATING GIVEN TO A STUDENT'S WORK",
  letters: ["A", "R", "G", "E", "D"],
  word: "GRADE"
  }, {
  answer: "EXAM",
  hint: "A TEST TO ASSESS A STUDENT'S KNOWLEDGE",
  letters: ["X", "E", "M", "A"],
  word: "EXAM"
  }, {
  answer: "BLUE",
  hint: "COLOR OF THE SKY AND OCEAN",
  letters: ["E", "L", "B", "U"],
  word: "BLUE"
  }, {
  answer: "RINGTONE",
  hint: "SOUND NOTIFICATIONS FOR CALLS",
  letters: ["G", "I", "N", "T", "R", "O", "E", "N"],
  word: "RINGTONE"
  }]
  
  ;

const ScrambleaWordPlay = ({ day }) => {
  const startIndex = (day - 1) * 5;
  const endIndex = startIndex + 5;
  const dayGameData = gameData.slice(startIndex, endIndex);
  const { userDetails, updateUserInfo,updatewatchScreenInfo,watchScreen } = useUserInfo();
  const userId = userDetails?.userDetails?.telegramId;
  const [selectedLetters, setSelectedLetters] = useState([]);
  const [disabledLetters, setDisabledLetters] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [scrambleIndex, setScrambleIndex] = useState(0);
  const [points, setPoints] = useState(0);
  const [isChecked, setIsChecked] = useState(false);
  const [isCorrect, setIsCorrect] = useState(false);
  const [message, setMessage] = useState("");
  const [messageColor, setMessageColor] = useState("");
  const [showAnswer, setShowAnswer] = useState(false);
  const [chancesOver, setChancesOver] = useState(false);
  const [showCompletionPopup, setShowCompletionPopup] = useState(false);
  const playClick = useAudio();
  const [isLoading,setIsLoading]=useState(false);
  const IsPointsReached = watchScreen?.LoginMessage=="You have already reached the maximum rewards limit"?true:false
  
  useEffect(() => {
    const savedScrambleIndex =
      parseInt(localStorage.getItem(`scrambleIndex_day${day}_${userId}`)) || 0;
    setScrambleIndex(savedScrambleIndex);
    const savedPoints =
      parseInt(localStorage.getItem(`points_day${day}_${userId}`)) || 0;
    setPoints(savedPoints);
  }, [day]);

  useEffect(() => {
    logPageView("ScramblewordPlay", "Scramble Word PlayPage");
  }, []);

  useEffect(() => {
    if (scrambleIndex >= 5) {
      setChancesOver(true);
      setShowCompletionPopup(true); // Trigger the completion pop-up
      localStorage.setItem(`scrambleIndex_day${day}_${userId}`, 5);
    } else {
      localStorage.setItem(`scrambleIndex_day${day}_${userId}`, scrambleIndex);
    }
    localStorage.setItem(`points_day${day}_${userId}`, points);
  }, [scrambleIndex, points, day]);

  const handleLetterClick = (letter, index) => {
    if (isChecked || chancesOver) return;
    if (inputValue.length !== dayGameData[scrambleIndex].word.length) {
      setMessage("");
    }
    if (disabledLetters.includes(index)) {
      const letterIndex = selectedLetters.indexOf(letter);
      if (letterIndex > -1) {
        const newSelectedLetters = [...selectedLetters];
        newSelectedLetters.splice(letterIndex, 1);
        const newInputValue =
          inputValue.slice(0, letterIndex) + inputValue.slice(letterIndex + 1);
        setSelectedLetters(newSelectedLetters);
        setDisabledLetters(disabledLetters.filter((i) => i !== index));
        setInputValue(newInputValue);
      }
    } else {
      setSelectedLetters([...selectedLetters, letter]);
      setDisabledLetters([...disabledLetters, index]);
      setInputValue(inputValue + letter);
    }
    playClick();
  };
  const checkWord = async () => {
    playClick();
    if (chancesOver) return;
    var gamePoints;
    setIsChecked(false);
    setIsCorrect(true);
    updateUserInfo((prev) => ({
      ...prev,
      isLoading: true,
    }));
    if (inputValue === dayGameData[scrambleIndex].word) {
      console.log("User Details:", userDetails);
      console.log("Early Users Limit:", userDetails?.earlyUsersLimitReached);
      const newPoints = points + (userDetails?.earlyUsersLimitReached ? 1000 : 2500);
      gamePoints = userDetails?.earlyUsersLimitReached ? 1000 : 2500;
      setPoints(newPoints);
    } else {
      gamePoints = userDetails?.earlyUsersLimitReached ? 0 : 500;
      const newPoints = points + (userDetails?.earlyUsersLimitReached ? 0 : 500);
      setPoints(newPoints);
    }
    const apiData = {
      gamePoints: String(gamePoints),
      gameType: "Scrambled",
    };
    const response = await userGameRewards(apiData);
    if (response) {
      setIsChecked(true);
      updateUserInfo((prev) => ({
        ...prev,
        isLoading: false,
      }));
      updatewatchScreenInfo((prev) => ({
        ...prev,
        LoginMessage: response?.message,
      }));

      if (inputValue === dayGameData[scrambleIndex].word) {
        setMessage(`${!IsPointsReached?"** Correct! You earned " + gamePoints + " points **":"Your Answer is Correct"} `);
        setMessageColor("green");  
        setShowAnswer(false);
      } else {
        setMessage(` ${!IsPointsReached?"** Incorrect! You earned " + gamePoints + " points **":"Your Answer is Incorrect"}`);
        setMessageColor("red");}
        setShowAnswer(true);
    }
    if (scrambleIndex >= 5) {
      setChancesOver(true);
      setShowCompletionPopup(true); // Trigger the completion pop-up
      localStorage.setItem(`scrambleIndex_day${day}_${userId}`, 5);
    } else {
      localStorage.setItem(
        `scrambleIndex_day${day}_${userId}`,
        scrambleIndex + 1
      );
    }
    localStorage.setItem(`points_day${day}_${userId}`, points);
  };

  const nextScramble = () => {
    playClick();
    var gamePoints;
    if (!isChecked) {
      setMessage("** Please check the word **");
      setMessageColor("red");
      return;
    }
    if (scrambleIndex >= 4) {
      setChancesOver(true);
      setShowCompletionPopup(true); // Show the pop-up after the last word is completed
      localStorage.setItem(`scrambleIndex_day${day}_${userId}`, 5);
      return;
    }

    setSelectedLetters([]);
    setDisabledLetters([]);
    setInputValue("");
    setIsChecked(false);
    setScrambleIndex(scrambleIndex + 1);
    setMessage("");
    setShowAnswer(false);
    setIsCorrect(false);
  };

  const toogleMenu = () => {
    playClick();
    updateUserInfo((prev) => ({
      ...prev,
      isPlay: false,
      currentComponent: scramble,
      currentComponentText: "scramble",
      lastComponent: userDetails?.userDetails.currentComponent,
      lastComponentText: userDetails?.userDetails.currentComponentText,
      isMenu: true,
      menuCount: userDetails?.userDetails?.menuCount + 1,
    }));
  };

  return (
    <div className="quiz-play-task">
      <img
        onClick={() => {
          toogleMenu();
        }}
        src='https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg'
        className="cancel-imgpoints"
        style={{ cursor: "pointer" }}
      />
      <div className="ScrambleaWordPlay">
        <h1 className="text-heading">WORD SCRAMBLE</h1>
        <h3 className="scramble-count">
          YOU HAVE {5 - scrambleIndex}/5 SCRAMBLE
        </h3>
      </div>
      <div>
        <div className="custom-search">
          <input
            type="text"
            className="custom-search-input"
            placeholder="Enter a valid word"
            value={inputValue}
            readOnly
          />
          <button
            className="custom-search-botton"
            type="button"
            onClick={checkWord}
            disabled={
              inputValue.length !== dayGameData[scrambleIndex].word.length ||
              isCorrect
            }
          >
            Check Word
          </button>
        </div>
      </div>
      <div className="scramble-wordbox-container">
        {dayGameData[scrambleIndex].letters.map((letter, index) => (
          <div
            key={index}
            className={`scramble-wordbox ${
              disabledLetters.includes(index) ? "disabled" : ""
            }`}
            onClick={() => handleLetterClick(letter, index)}
          >
            <p className="word-s">{letter}</p>
          </div>
        ))}
      </div>
      <div className="margin">
        <h2 className="hint-text">Hint</h2>
        <h2 className="first-cryptocurrency">
          {dayGameData[scrambleIndex].hint}
        </h2>
      </div>
      {message && (
        <p className="message1`" style={{ color: messageColor }}>
          {message}
        </p>
      )}
      {showAnswer && (
        <p className="answer">
          Correct Answer: {dayGameData[scrambleIndex].answer}
        </p>
      )}
      <button
        className={`${!isChecked ? "quitz-dsb" : "quitz-btn "}`}
        disabled={!isChecked}
        onClick={nextScramble}
      >
        Next
      </button>
      {chancesOver && showCompletionPopup && !IsPointsReached  ?(
        <div className={`popup ${showCompletionPopup ? "show" : ""}`}>
          <div className="popup-content">
            <h2 className="epic">{points === 0 ? "Better Luck Next Time!" : "Epic Win!"}</h2>
            <div className="row text-center">
              <div className="col-12">
                <div className="epic-div">
                  <p className="pointsLabel">TOKENS EARNED</p>
                  <div className="pointsValue1">
                    <img src='https://d1ccopf5cw1hft.cloudfront.net/s3data/coinlogo.png' alt="logo" />
                    <p className="pointsNumber">{points}</p>
                  </div>
                </div>
                <p className="bottom-text">
                  Play daily to boost your score and rack up more points!
                </p>
              </div>
            </div>
          </div>
        </div>
      ):chancesOver && showCompletionPopup && IsPointsReached?
      <div className={`popup ${showCompletionPopup ? "show" : ""}`}>
          <div className="popup-content">
            <h2 className="epic">Come back later!</h2>
            <div className="row text-center">
              <div className="col-12">
                
                <p className="bottom-text">
                You've completed this day's scramble words. Please return tomorrow to
                continue!
                </p>
              </div>
            </div>
          </div>
        </div>
        :''
      }
    </div>
  );
};
export default ScrambleaWordPlay;
